// Moment?

export function timestampComparator(valueA: any, valueB: any) {

    //an invalid date will cause valueOf() to return NaN
    // new Date(null).valueOf() = 0
    // new Date(undefined).valueOf() = NaN
    // new Date("").valueOf() = NaN
    //const valA = new Date(valueA as string).valueOf() ?? 0;
    //const valB = new Date(valueB as string).valueOf() ?? 0;

    const valA = new Date(valueA as string).valueOf() || 0;
    const valB = new Date(valueB as string).valueOf() || 0;
    
    if (valA === valB) {
        return 0;
    } else {
        return (valA > valB) ? 1 : -1;
    }
}
